export const iconFontAwesomeArrowsCircleChevronLeft = (
	<i className="fa-solid fa-circle-chevron-left"></i>
);
